// platform/src/components/mw/MwLogo.tsx
//
// Logo MentorWallet reutilizable. Solo wordmark Bricolage Grotesque
// (Miguel decidió quitar el imagotipo previo).
//
// Tokens consumidos desde styles/mw.css.

interface MwLogoProps {
  size?: 'sm' | 'md' | 'lg'
  variant?: 'positive' | 'negative'
  className?: string
}

const SIZE_CONFIG = {
  sm: '18px',
  md: '22px',
  lg: '28px',
} as const

export function MwLogo({
  size = 'md',
  variant = 'positive',
  className = '',
}: MwLogoProps) {
  const fontSize = SIZE_CONFIG[size]
  const inkColor = variant === 'positive' ? 'var(--mw-ink)' : 'var(--mw-ink-inverse)'

  return (
    <span
      className={`inline-flex items-center ${className}`}
      style={{
        fontFamily: 'var(--mw-font-display)',
        fontSize,
        fontWeight: 700,
        letterSpacing: '-0.025em',
        color: inkColor,
        lineHeight: 1,
      }}
    >
      MentorWallet
    </span>
  )
}
